import { Form } from "antd";
import { HeaderOverview } from "components";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashboardAppSummary } from "service/dashboard/property/overview";
import { SpaceStyle } from "..";
import { LoadingDashboard, Wrapper } from "../..";

const Summary = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();
  const summaryPropertyDate = Form.useWatch("summaryPropertyDate");
  const date = findDate(summaryPropertyDate, "month");

  const data = useGetPropertyDashboardAppSummary({
    ...date,
  });

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={false}>
        <HeaderOverview
          title={t("summary-of-user")}
          name="summaryPropertyDate"
        />
        <SpaceStyle className="center " direction="vertical">
          <div className="count"style={{fontSize:"36px"}}>{`${data.data || "0"}`}</div>
          <div className="people"style={{fontSize:"24px"}}>{t("people")}</div>
        </SpaceStyle>
      </LoadingDashboard>
    </Wrapper>
  );
};

export default Summary;
